// extracted by mini-css-extract-plugin
module.exports = {"OpportunityActionsBar":"_2jjkTG5G","paginationBar":"_1D3y3PXH","sortDropdown":"H-wYjOTP"};